import styled from "styled-components"

import useShippingList from "hooks/shipping/useShppingList"

import ShippingItem from "../ShippingItem"
import AddShippingBtn from "../AddShippingBtn"
import DefaultShippingCheckBox from "../DefaultShippingCheckBox"
import SaveBtn from "../SaveBtn"

export default function ShippingList({ onComplete }) {
  const {
    shippingList,
    currShipping,
    isChangeDefault,
    handleDeleteShipping,
    handleChangeCurrShipping,
    handleToggleDefault,
    openShippingAddressForm,
    handleSave,
  } = useShippingList({ onComplete })

  return (
    <>
      <Wrapper>
        {Array.isArray(shippingList) &&
          shippingList.length > 0 &&
          shippingList.map((shipping) => (
            <ShippingItem
              key={`shipping-address-no-${shipping.no}`}
              shipping={shipping}
              onCheck={() => handleChangeCurrShipping(shipping)}
              isChecked={currShipping?.no === shipping.no}
              onDelete={handleDeleteShipping}
            />
          ))}
        <AddShippingBtn onClick={openShippingAddressForm} />
        <DefaultShippingCheckBox onCheck={handleToggleDefault} isChangeDefault={isChangeDefault} />
      </Wrapper>
      <SaveBtn onClick={handleSave} />
    </>
  )
}

const Wrapper = styled.div`
  position: relative;
  padding: 0 calc(100vw * (17 / 375));
  padding-top: calc(100vw * (19 / 375));
  padding-bottom: calc(100vw * (19 / 375));
  flex: 1 1 auto;
  overflow-y: scroll;
`
